import styled from 'styled-components';

export const Title = styled.h2`
  margin: 0;
  color: #000000;
  font-weight: 600;
  font-size: 16px;
  line-height: 0.5;
  word-wrap: break-word;
  margin-bottom: 24px;
`

export const FooterWrapper =  styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin: 20px 0 0;
`

export const FlexFill = styled.div`
  flex:1;
`

export const RollingWindowWrapper = styled.div`
  gap: 8px;
  display: flex;
  align-items: baseline;
`;
